import { PouchDB } from "./PouchDB";
import { PouchDbStore } from "./PouchDbStore";
import { ICard } from "../../domain/cards/ICard";
import { ICardRepository } from "../../domain/cards/ICardRepository";

export class CardRepository extends PouchDbStore<ICard> implements ICardRepository {
    constructor() {
        super("Cards");
        this.replicate();
    }
    replicate() {
        const remoteDb = new PouchDB('https://db.solidt.eu/cards/', {
            auth: {
                username: "nexib",
                password: "Welkom123"
            }
        });
        this.db.sync(remoteDb, {
          live: true,
          retry: true
        }).on('change', function (change) {
          // yo, something changed!
          console.log('change', change);
        }).on('paused', function (info) {
          // replication was paused, usually because of a lost connection
          console.log('paused', info);
        })
        // .on('active', function (info) {
        //   // replication was resumed
        // })
        .on('error', function (err) {
          // totally unhandled error (shouldn't happen)
          console.log('error', err);
        });

    }
}
